export const cardData = [
  {
    title: "Languages",
    skills: ["C", "C++", "JavaScript", "Java", "Python"],
  },
  {
    title: "Experience",
    skills: [
      "Hackathons",
      "Workshops",
      "College Projects",
      "Full-Stack Development",
      "Backend Development",
    ],
  },
  {
    title: "Services",
    skills: [
      "Web Development",
      "UI/UX Design",
      "MERN Stack Development",
      "Data Science",
    ],
  },
];

export const iconSlugs = [
  "typescript",
  "javascript",
  "dart",
  "java",
  "react",
  "flutter",
  "android",
  "html5",
  "css3",
  "nodedotjs",
  "express",
  "nextdotjs",
  "prisma",
  "amazonaws",
  "postgresql",
  "firebase",
  "nginx",
  "vercel",
  "testinglibrary",
  "jest",
  "cypress",
  "docker",
  "git",
  "jira",
  "github",
  "gitlab",
  "visualstudiocode",
  "androidstudio",
  "sonarqube",
  "figma",
];

export const aboutText = `
I'm Aadit Yadav, a passionate Software Engineering student with a keen interest in web development, data science, and machine learning. Currently, I'm honing my skills in Python development, building intuitive web applications using React, and exploring AI-powered and data-driven technologies.

Throughout my learning journey, I've worked on projects involving API integration, backend development, frontend development, and full-stack web applications.

Beyond coding, I'm always curious about emerging technologies and continuously seek opportunities to expand my knowledge. I enjoy contributing to innovative projects, solving real-world problems, and collaborating with people in the tech community.

Passionate about turning ideas into impactful digital experiences.

Feel free to explore my work, and let's collaborate!
`;